import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, siteInfo } from '@/mocks/home';
import { getCategoryArticles, allArticles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = getCategoryArticles(slug || '');
  const catName = category ? category.name : '分类';

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${catName} - ${siteInfo.name}`,
    description: category?.description || `${catName}相关爆料文章`,
    url: `https://lymeijialaifu.cn/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://lymeijialaifu.cn',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://lymeijialaifu.cn' },
        { '@type': 'ListItem', position: 2, name: catName, item: `https://lymeijialaifu.cn/category/${slug}` },
      ],
    },
  };

  return (
    <>
      <title>{catName} - {siteInfo.name} | 吃瓜爆料分类浏览</title>
      <meta name="description" content={category?.description || `${catName} - 黑料吃瓜爆料中心为您提供最新最全的${catName}相关爆料资讯，有据可查，实时更新。`} />
      <meta name="keywords" content={`${catName},吃瓜爆料,${siteInfo.keywords}`} />
      <link rel="canonical" href={`https://lymeijialaifu.cn/category/${slug}`} />
      <meta property="og:title" content={`${catName} - ${siteInfo.name}`} />
      <meta property="og:description" content={category?.description || `${catName}相关爆料文章`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://lymeijialaifu.cn/category/${slug}`} />
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="bg-background-100 py-10 md:py-14">
            <div className="px-4 md:px-6 max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
                <Link to="/" className="hover:text-foreground-950 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-950 font-medium">{catName}</span>
              </nav>

              <div className="flex items-center gap-4 mb-2">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${category?.icon || 'ri-folder-line'} text-lg`}></i>
                </span>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {catName}
                  </h1>
                  <p className="text-foreground-500 text-sm mt-1">
                    {category?.description || `浏览所有${catName}相关爆料`}
                  </p>
                </div>
              </div>
              <p className="text-xs text-foreground-400 mt-2">
                共 <strong className="text-foreground-700">{articles.length}</strong> 篇文章
              </p>
            </div>
          </div>

          <div className="px-4 md:px-6 max-w-7xl mx-auto py-10 md:py-14">
            {articles.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {articles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:-translate-y-1 transition-all duration-300"
                    >
                      <div className="relative aspect-[16/10] overflow-hidden">
                        <img
                          src={article.imageUrl}
                          alt={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-950 text-xs font-semibold">
                            {article.category}
                          </span>
                        </div>
                      </div>
                      <div className="p-4">
                        <h3 className="text-foreground-950 font-semibold text-sm leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center justify-between text-xs text-foreground-400">
                          <span>{article.time}</span>
                          <span className="flex items-center gap-1">
                            <i className="ri-fire-line text-accent-500"></i>
                            {article.hotScore}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>

                {articles.length > 6 && (
                  <div className="mt-10 flex justify-center gap-3">
                    <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 text-sm font-medium cursor-pointer hover:bg-background-200 transition-colors">
                      1
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer">
                      2
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 text-sm font-medium cursor-pointer hover:bg-background-200 transition-colors">
                      3
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 text-sm cursor-pointer hover:bg-background-200 transition-colors">
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <h2 className="font-heading text-xl font-bold text-foreground-700 mb-2">
                  暂无相关内容
                </h2>
                <p className="text-foreground-500 text-sm mb-6">
                  该分类下暂时还没有文章，请查看其他分类
                </p>
                <Link
                  to="/"
                  className="inline-block whitespace-nowrap px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  返回首页
                </Link>
              </div>
            )}
          </div>

          <div className="bg-background-100 py-8 md:py-10">
            <div className="px-4 md:px-6 max-w-7xl mx-auto">
              <h2 className="font-heading text-lg font-bold text-foreground-950 mb-5">
                浏览其他分类
              </h2>
              <div className="flex flex-wrap gap-3">
                {categories
                  .filter((c) => c.slug !== slug)
                  .map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="whitespace-nowrap px-4 py-2 rounded-full border border-background-300/60 text-foreground-600 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <i className={`${cat.icon} mr-1.5`}></i>
                      {cat.name}
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}